import { FieldErrors } from 'react-hook-form'
import get from 'lodash/get'
import isNaN from 'lodash/isNaN'
import * as yup from 'yup'
import { REQUIRED_MESSAGE } from '../../../constants'

export const DedicatedLanesPreferenceSchema = yup.object({
  isInterestedInDedicatedLanes: yup.boolean().nullable().required(REQUIRED_MESSAGE),
  minimumRatePerMile: yup
    .number()
    .nullable()
    .when('isInterestedInDedicatedLanes', {
      is: true,
      then: yup
        .number()
        .transform(val => (isNaN(val) ? null : val))
        .required(REQUIRED_MESSAGE),
    }),
})

export type TDedicatedLanesPreferenceSchema = yup.InferType<typeof DedicatedLanesPreferenceSchema>

export const getErrorMessage = <
  T extends FieldErrors<TDedicatedLanesPreferenceSchema>,
  K extends keyof T
>(
  errors: T,
  keyName: K
): string | undefined => {
  return get(errors, [keyName, 'message'])
}
